import Box from '@mui/joy/Box'
import Card from '@mui/joy/Card'
import CardActions from '@mui/joy/CardActions'
import CardContent from '@mui/joy/CardContent'
import Divider from '@mui/joy/Divider'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Input from '@mui/joy/Input'
import Typography from '@mui/joy/Typography'
import Button from '@mui/joy/Button'
import Business from '@mui/icons-material/Business'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import Textarea from '@mui/joy/Textarea'

export const OrganizationInfo = ({ data, onSubmit }) => {
    const handleSubmit = (e) => {
        e.preventDefault()
        const data = new FormData(e.currentTarget)
        const name = data.get('name')
        const description = data.get('description')

        onSubmit({ name, description })
    }

    return (
        <Card
            variant="outlined"
            sx={{
                maxHeight: 'max-content',
                maxWidth: '100%',
                width: '50%',
                overflow: 'auto',
            }}
        >
            <Typography level="title-lg" startDecorator={<Business />}>
                Organization Info
            </Typography>
            <Divider inset="none" />
            <form onSubmit={handleSubmit}>
                <CardContent
                    sx={{
                        gap: 1.5,
                    }}
                >
                    <FormControl sx={{ gridColumn: '1/-1' }}>
                        <FormLabel>Name</FormLabel>
                        <Input name="name" defaultValue={data.name} />
                    </FormControl>
                    <FormControl sx={{ gridColumn: '1/-1' }}>
                        <FormLabel>Description</FormLabel>
                        <Textarea
                            name="description"
                            placeholder={'A little bit about your company...'}
                            defaultValue={data.description}
                            minRows={8}
                            maxRows={10}
                        />
                    </FormControl>
                    <CardActions>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <Button
                                variant="solid"
                                color="primary"
                                type="submit"
                                disabled
                            >
                                Update
                            </Button>
                        </Box>
                    </CardActions>
                </CardContent>
            </form>
        </Card>
    )
}
